// import { requestEncrypt, returnDecrypt, requestDecrypt } from './fuse.auth'
import { requestEncrypt, returnDecrypt } from './fuse.auth'
// import { requestEncrypt, returnDecrypt } from '@/utility/fuse.auth'
import $jsonp from './jsonp'
const userAgent = navigator.userAgent.toLowerCase()

const isMobile = /mobile/i.test(userAgent)

const isAndroid = /android/i.test(userAgent)

const isIOS = /iphone|ipad|ipod|macintosh/i.test(userAgent)

const isWX = /MicroMessenger/i.test(userAgent)

const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)

const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || document.referrer.includes('android-app://')

const getSession = key => JSON.parse(sessionStorage.getItem(key) || '{}')
const saveSession = (key, value) => sessionStorage.setItem(key, JSON.stringify(value))
const removeSession = key => sessionStorage.removeItem(key)
const uuid = () => {
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
}
const isPhoneNum = num => {
  return /^1\d{10}$/.test(num)
}
const getURLparams = () => {
  let url = location.search // 获取url中"?"符后的字串
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}
const ajax = (...arg) => {
  let payload = [...arg]
  // 加密KEY生成
  let KEY = String(new Date().getTime()).substr(0, 10)
  if (!payload[2]) payload[2] = {}
  // 建立筛选
  payload[2].filter = function (obj) {
    let { ct, ac } = obj
    let newObj = { ...obj }
    delete newObj.ac
    delete newObj.ct

    log(`${arg[0]}(input)`, arg[1])

    return {
      ct,
      // ac,
      ...(ac ? {
        ac
      } : {}),
      p: requestEncrypt(JSON.stringify(newObj), KEY).e,
      ts: KEY,
      js: 1
    }
  }
  return new Promise((resolve, reject) => {
    $jsonp(
      payload[2].domain = payload[2].domain || configUrl.__daqianapiDomain.get(),
      payload[2].filter(payload[1])
    ).then(res => {
      log(res)
      if (res.data && res.data.d) {
        res.data = JSON.parse(returnDecrypt(res.data.d, String(res.data.ts)).d)
      }
      if (res.code !== 0) {
        // ... 错误处理
        showMsg(res.msg)
      }
      log(`${arg[0]}(res)`, res)
      resolve(res)
    })
      .catch(e => {
        log('FN._ajax error:', e)
      })
  })
}

const fuseSdkAjax = (...arg) => {
  let payload = [...arg]
  // 加密KEY生成
  let KEY = String(new Date().getTime()).substr(0, 10)
  if (!payload[2]) payload[2] = {}
  // 建立筛选
  payload[2].filter = function (obj) {
    let { ct, ac } = obj
    let newObj = { ...obj }
    delete newObj.ac
    delete newObj.ct

    log(`${arg[0]}(input)`, arg[1])

    return {
      ct,
      ac,
      p: requestEncrypt(JSON.stringify(newObj), KEY).e,
      ts: KEY,
      is_jsdk: 1,
      js: 1
    }
  }
  return new Promise((resolve, reject) => {
    $jsonp(
      payload[2].domain,
      payload[2].filter(payload[1])
    ).then(res => {
      if (res.data && res.data.d) {
        res.data = JSON.parse(returnDecrypt(res.data.d, String(res.data.ts)).d)
      }
      if (res.code !== 0) {
        // ... 错误处理
        showMsg(res.msg)
      }
      log(`${arg[0]}(res)`, res)
      resolve(res)
    })
      .catch(e => {
        log('FN._fuse_sdk_ajax error:', e)
      })
  })
}

function showMsg (txt = '', Autoclose = true) {
  let msg = document.createElement('div')
  msg.innerHTML = `
        <div className="msg" style="
        position: fixed;
        left:50%;
        top:50%;
        margin-left:-2rem;
        font-size: 0.28rem;
        padding: 0.2rem 0.3rem;
        border-radius: 0.08rem;
        background: rgba(0, 0, 0, 0.8);
        line-height: 1.5;
        text-align: center;
        width: 4rem;
        color: #fff;
        word-break:break-all;
        z-index:9999999";
        id="show_tip">
            ${txt}
        </div>
    `
  document.body.appendChild(msg)
  if (Autoclose) {
    setTimeout(() => {
      document.body.removeChild(msg)
    }, 1500)
  } else {
    document.getElementById('show_tip').parentNode.onclick = function () {
      document.body.removeChild(msg)
    }
  }
}
function inject (container, src, tag = 'iframe') {
  let context = document.createElement(tag)
  context.id = 'i-' + new Date().getTime()
  if (tag === 'link') {
    context.href = src
    context.rel = 'stylesheet'
  } else {
    context.src = src
  }
  document.querySelectorAll(container)[0].appendChild(context)
  return new Promise((resolve, reject) => {
    context.onload = () => resolve(context)
  })
}
const log = (string, data) => {
  // console.log(string, data)
  // if (getURLparams().debug) {
  //   data ? console.log(string, data) : console.log(string)
  // }
  // let getSession = key => JSON.parse(sessionStorage.getItem(key) || '{}')
  // if (getSession('FUSE_INIT_INFO').is_debug === '1') {
  //   data ? console.log(string, data) : console.log(string)
  // }
  // data ? console.log(string, data) : console.log(string)
}
const post = (data) => {
  let adata = {
    type: 'CC',
    ...data
  }
  document.getElementById('iframe').contentWindow.postMessage(adata, '*')
}
const getRandomChar = (len, type) => {
  function getChar (chars) {
    return chars.charAt(Math.floor(Math.random() * chars.length))
  }
  let charsNum = '0123456789'
  let charsString = 'qwertyuiopasdfghjklzxcvbnm'
  let chars = '0123456789qwertyuiopasdfghjklzxcvbnm'

  let result = ''
  let useChars = ''

  if (type === 'string') {
    useChars = charsString
  } else if (type === 'number') {
    useChars = charsNum
  } else {
    useChars = chars
  }
  while (len--) {
    result += getChar(useChars)
  }
  return result
}
export default {
  wrap (data) {
    return {
      statusCode: typeof data.statusCode === 'undefined' ? data.code : data.statusCode,
      status: typeof data.status === 'undefined' ? data.msg : data.status
    }
  },
  getURLparams,
  ajax,
  fuseSdkAjax,
  isMobile,
  isAndroid,
  isIOS,
  isWX,
  isSafari,
  isInStandaloneMode,
  getSession,
  saveSession,
  removeSession,
  inject,
  log,
  uuid,
  post,
  getLocal: key => JSON.parse(localStorage.getItem(key) || '{}'),
  saveLocal: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
  removeLocal: key => localStorage.removeItem(key),
  isPhoneNum,
  getRandomChar,
  showMsg
}
